import $ from 'jquery'

let collapseTimer: number | null = null
let expansionTimer: number | null = null
const getHeightOfChildren = function ($element: JQuery): number {
  let totalHeight = 0
  $element.children().each(function () {
    totalHeight += $(this).outerHeight(true)!
  })
  return totalHeight
}
const setMaxHeight = function ($outerItem: JQuery): void {
  const $inner = $outerItem.find('> .collapse-inner')
  const hiddenHeight = getHeightOfChildren($inner)
  const currentMaxHeight = parseInt($inner.css('max-height') || '0', 10)
  // If the menu item's initial state is set to 'opened', the current max-height will be 'none' (NaN)
  if (hiddenHeight > currentMaxHeight || isNaN(currentMaxHeight)) {
    $inner.css('max-height', hiddenHeight)
  }

  // If this accordian is nested inside a parent accordian element, expand the parent accordian element, so that its
  // height won't limit the expansion of its children
  if ($outerItem.closest('.collapse-inner').length) {
    const $mostOuterItem = $outerItem.closest('.collapse-inner')
    $mostOuterItem.css('max-height', 'none')
  }
}
export default function (e: JQuery.Event, $outerItem: JQuery): void | string {
  let $iconPlusXs: JQuery
  const isMobile = window.matchMedia('(max-width: 767px)').matches
  const closedOnMobile = isMobile && $outerItem.hasClass('opened-sm')
  const openOnDesktop = !isMobile && $outerItem.hasClass('opened-sm')
  if (collapseTimer != null) {
    clearTimeout(collapseTimer)
    collapseTimer = null
  }
  if (expansionTimer != null) {
    clearTimeout(expansionTimer)
    expansionTimer = null
  }
  if ($outerItem.hasClass('closed') || closedOnMobile) {
    e.preventDefault()
    $iconPlusXs = $outerItem.find(
      '> .collapse-container__section-title .icon-plus--xs'
    )
    const $iconPlus = $outerItem.find(
      '> .collapse-container__section-title .icon-plus'
    )
    if ($iconPlusXs.length) {
      $iconPlusXs
        .removeClass('icon-plus--xs')
        .removeClass('icon-plus')
        .removeClass('icon-minus')
        .addClass('icon-minus')
    } else {
      $iconPlus.removeClass('icon-plus').addClass('icon-minus')
    }
    window.requestAnimationFrame(function () {
      setMaxHeight($outerItem)
      $outerItem.removeClass('closed').addClass('opened')
      $outerItem.removeClass('opened-sm')

      // Reset to the original state so that if we switch from mobile to desktop, the element will be at its natural
      // height.
      expansionTimer = window.setTimeout(
        () => $outerItem.find('> .collapse-inner').css('max-height', ''),
        600
      )
    })
    return 'Expanded'
  } else if ($outerItem.hasClass('opened') || openOnDesktop) {
    e.preventDefault()

    // Set the max-height first so that the inline style will override the default max-height
    // for items whose initial state is set to 'opened'
    setMaxHeight($outerItem)
    $iconPlusXs = $outerItem.find(
      '> .collapse-container__section-title .icon-plus--xs'
    )
    const $iconMinus = $outerItem.find(
      '> .collapse-container__section-title .icon-minus'
    )
    if ($iconPlusXs.length) {
      $iconPlusXs
        .removeClass('icon-plus--xs')
        .removeClass('icon-plus')
        .removeClass('icon-minus')
        .addClass('icon-plus')
    } else {
      $iconMinus.removeClass('icon-minus').addClass('icon-plus')
    }
    window.requestAnimationFrame(function () {
      // Reset the max-height as the .collapse-inner class should have a max-height: 0 style by default
      $outerItem.find('> .collapse-inner').css('max-height', '')
      $outerItem.removeClass('opened').addClass('closed')
      $outerItem.removeClass('opened-sm')

      // Reset to the original state so that if we switch from mobile to desktop, the content of accordians with their
      // section title hidden and closed by default on mobile is shown.
      collapseTimer = window.setTimeout(function () {
        if (
          $outerItem.hasClass(
            'collapse-outer-item--section-title-visible-xs'
          ) &&
          $outerItem.hasClass('collapse-outer-item--xs-closed')
        ) {
          $outerItem.find('> .collapse-inner').css('max-height', '')
          $outerItem.addClass('opened-sm')
          $outerItem.removeClass('closed')
        }
      }, 600) // max-height animation occurs over 600ms
    })

    return 'Collapsed'
  }
}
